import React from 'react';
import { useAuth } from 'hooks';
import { Box, Container, Stack, Typography } from '@mui/material';
import { Security } from '@mui/icons-material';
import { SupportModeDeactivateButton } from './SupportModeDeactivateButton';

export const SupportModeBanner = () => {
  const { user, impersonator } = useAuth();

  if (!impersonator) {
    return null;
  }

  return (
    <Box sx={{ background: (theme) => theme.palette.error.dark }}>
      <Container sx={{ my: 4 }}>
        <Stack direction={{ xs: 'column', md: 'row' }} spacing={4} justifyContent="space-between" alignItems="center">
          <Stack direction={{ xs: 'column', md: 'row' }} spacing={{ xs: 4, md: 10 }} alignItems="center">
            <Stack direction="row" alignItems="center" spacing={2}>
              <Security sx={{ color: '#FFFFFF', width: { xs: 24, md: 32 }, height: { xs: 24, md: 32 } }} />
              <Typography
                sx={{ fontSize: { xs: '20px', md: '24px' }, fontWeight: 700 }}
                textTransform="uppercase"
                color="#FFFFFF"
              >
                Support-modus ist active
              </Typography>
            </Stack>
            <SupportModeDeactivateButton />
          </Stack>

          <Stack>
            <Typography variant="h4" sx={{ textAlign: { xs: 'center', md: 'right' } }} color="#FFFFFF">
              Eingeloggt im Namen von
            </Typography>
            <Typography variant="h4" sx={{ textAlign: { xs: 'center', md: 'right' } }} color="#FFFFFF">
              {user?.email}
            </Typography>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
};
